"use client";

import * as NavigationMenuPrimitive from "@radix-ui/react-navigation-menu";
import { type FC, useState } from "react";

import {
  type THeaderMenuVariantProps,
} from "@/ui/components/navigation/Header/Header.config";
import {
  HeaderMenuLinks,
} from "@/ui/components/navigation/Header/HeaderMenuLinks";
import {
  HeaderMenuToggle,
} from "@/ui/components/navigation/Header/HeaderMenuToggle";
import {
  HeaderMenuTrigger,
} from "@/ui/components/navigation/Header/HeaderMenuTrigger";
import {
  HeaderMenuViewport,
} from "@/ui/components/navigation/Header/HeaderMenuViewport";
import {
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
} from "@/ui/components/navigation/NavigationMenu";
import { cn } from "@/ui/lib/utils";

export const HeaderDesktopMenu: FC<THeaderMenuVariantProps> = ({ items }) => {
  const [ isMenuOpen, setIsMenuOpen ] = useState(false);

  return (
    <NavigationMenuPrimitive.Root
      data-component="HeaderDesktopMenu"
      onValueChange={(value) => setIsMenuOpen(Boolean(value))}
      className={cn(
        "group/navigation-menu relative flex max-w-max flex-1 items-center justify-center",
      )}
    >
      <NavigationMenuList>
        <NavigationMenuItem>
          <HeaderMenuTrigger aria-label="Toggle menu">
            <HeaderMenuToggle open={isMenuOpen} />
          </HeaderMenuTrigger>
          <NavigationMenuContent>
            <HeaderMenuLinks items={items} variant="navigation-menu" />
          </NavigationMenuContent>
        </NavigationMenuItem>
      </NavigationMenuList>
      <HeaderMenuViewport />
    </NavigationMenuPrimitive.Root>
  );
};

HeaderDesktopMenu.displayName = "HeaderDesktopMenu";
